import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import TagsOuvidoriaFilter from './MotivosOuvidoriaFilter';
import TagsOuvidoriaHeader from './MotivosOuvidoriaHeader';
import TagsOuvidoriaTable from './MotivosOuvidoriaTable';
import { useTagsOuvidoriaListagem, useTagsOuvidoriaNavegacao } from '../hooks';

const TagsOuvidoriaCard = ({
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true,
}) => {
  const {
    data,
    loading,
    filterLoading,
    deleteLoading,
    showDeleteModal,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    filtrosUI,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    handleCancelarExclusao,
    handleConfirmarExclusao,
    setPaginaAtual,
    setQuantidadePorPagina,
  } = useTagsOuvidoriaListagem();

  const { handleAdicionar, handleEditar, handleRowClick } = useTagsOuvidoriaNavegacao();

  return (
    <Card>
      <CardBody>
        {showHeader && (
          <TagsOuvidoriaHeader
            totalRegistros={totalRegistros}
            onAdicionar={showActions ? handleAdicionar : undefined}
          />
        )}

        {showFilter && (
          <TagsOuvidoriaFilter
            loading={filterLoading}
            values={filtrosUI}
            onApply={handleFilterApply}
            onLimpar={handleLimparFiltros}
          />
        )}

        <TagsOuvidoriaTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={{
            pageIndex: Math.max(0, (paginaAtual || 1) - 1),
            pageSize: quantidadePorPagina || 10,
          }}
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') {
              setQuantidadePorPagina(next.pageSize);
            }

            if (next && typeof next.pageIndex === 'number') {
              setPaginaAtual(next.pageIndex + 1);
            }
          }}
        />

        <ConfirmDeleteModal
          show={showDeleteModal}
          onClose={handleCancelarExclusao}
          onConfirm={handleConfirmarExclusao}
          loading={deleteLoading}
          title="Excluir tag da ouvidoria"
          message="Tem certeza que deseja excluir esta tag da ouvidoria? Esta acao nao pode ser desfeita."
        />
      </CardBody>
    </Card>
  );
};

export default TagsOuvidoriaCard;
